module.exports = __webpack_public_path__ + "static/media/bg-shorten-desktop.a82de60e.svg";